import { SelectionRestrictionType } from '../Behaviors.types';
import {
    getSelectedTableView,
    getIsEverythingSelectedInTable,
    TableView,
} from 'owa-mail-list-store';
//import { assertNever } from 'owa-assert';

const selectionRestriction = (selectionRestrictionTypes: SelectionRestrictionType[]) => () => {
    const tableView: TableView = getSelectedTableView();
    const selectedRowsCount = tableView.selectedRowKeys.size;
    var foundSelectionRestriction = false;

    for (var selectionRestrictionType of selectionRestrictionTypes) {
        switch (selectionRestrictionType) {
            case SelectionRestrictionType.NoSelection:
                // Exclude the select all mode, because the selection is virtual and list view actually has no selected items.
                foundSelectionRestriction =
                    selectedRowsCount == 0 && !tableView.isInVirtualSelectAllMode;
                break;

            case SelectionRestrictionType.HasSelection:
                foundSelectionRestriction = selectedRowsCount > 0;
                break;

            case SelectionRestrictionType.SelectAll:
                foundSelectionRestriction = getIsEverythingSelectedInTable(tableView);
                break;

            case SelectionRestrictionType.SingleSelection:
                foundSelectionRestriction = selectedRowsCount == 1;
                break;

            case SelectionRestrictionType.MultipleSelection:
                foundSelectionRestriction = selectedRowsCount > 1;
                break;

            // default:
            //     throw assertNever(selectionRestrictionType);
        }

        // break as soon as we find listview satisfying the selection restriction
        if (foundSelectionRestriction) {
            return true;
        }
    }

    return false;
};

export default selectionRestriction;
